import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Sidan hittades inte | AdiStore</title>
        <meta name="description" content="Sidan du söker finns inte. Gå tillbaka till startsidan för att hitta våra varuautomater." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Sidan hittades inte</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Till startsidan
        </a>
      </div>
    </div>
  );
};

export default NotFound;
